import React, { useEffect, useState } from "react";
import { InformacionProceso } from "../../components/ProcesosDeCalificacion/InformacionProceso";
import { ParticipantesExcluidos } from "../../components/ProcesosDeCalificacion/ParticipantesExcluidos";
import { ExcluirFuncionario } from "../../components/ProcesosDeCalificacion/ExcluirFuncionario";
import { EliminarExcluido } from "../../components/ProcesosDeCalificacion/EliminarExcluido";
import { EliminarProceso } from "../../components/ProcesosDeCalificacion/EliminarProceso";
import { ActualizarParticipante } from "../../components/Participantes/ActualizarParticipante";

import Swal from "sweetalert2";
import xlsx from "json-as-xlsx";
import { ActualizarPrecalificadores } from "../../components/PreCalificadores/ActualizarPrecalificadores";
import { ActualizarJuntaCalificadora } from "../../components/ProcesosDeCalificacion/JuntaCalificadora/ActualizarJuntaCalificadora";
import { PlaceholderColumnas } from "../../components/Otros/Placeholder";
import { AsignarParticipantes } from "../../components/ProcesosDeCalificacion/AsignarParticipantes";
import { cerrarProceso } from "../../utils/Datos";
import { useParams } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import { UrlWs } from "../../utils/Global";

export const EditarProceso = () => {
  const { id_process } = useParams();

  const [updateProceso, setUpdateProceso] = useState(true);
  const [datosProceso, setDatosProceso] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);
  const [cargandoDatosExcel, setCargandoDatosExcel] = useState(false);
  const [error, setError] = useState("");
  const [participanteExcluido, setParticipanteExcluido] = useState(null);
  const [recargar, setRecargar] = useState(null);
  const [limpiar, setLimpiar] = useState(0);
  const [cerrandoProceso, setCerrandoProceso] = useState(false);

  const handleCerrarProceso = async () => {
    setCerrandoProceso(true);
    cerrarProceso(id_process).then((respuesta) => {
      if (respuesta.status === true) {
        Swal.fire({
          title: "Listo",
          text: "Sesión finalizada",
          icon: "success",
          confirmButtonText: "Ok",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: "Ocurrió un error al cerrar el proceso",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCerrandoProceso(false);
    });
  };

  const exportarExcel = async () => {
    if (cargandoDatosExcel === false) {
      setCargandoDatosExcel(true);
      const url = UrlWs + `/participants/${id_process}/excel`;
      Swal.fire({
        title: "Exportando",
        text: "El archivo se descargará automáticamente en unos intantes",
        icon: "success",
        confirmButtonText: "Ok",
      });
      await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          return response.json();
        })
        .then((datos) => {
          for (let x = 0; x < datos.length; x++) {
            datos[x].status = datos[x].status ? "ACTIVO" : "INACTIVO";
          }
          const planilla = [
            {
              sheet: "Participantes",
              columns: [
                { label: "Funcionario", value: "officerName" },
                { label: "RUT", value: "officerRut" },
                { label:"Escalafón",value:"scale_officer"},
                { label:"Grado",value:"gradeOfficer"},
                { label: "Email", value: "emailParticipant" },
                { label: "Dirección Municipal", value: "nameDmunicipal" },
                { label: "Unidad Municipal", value: "nameUmunicipal" },
                { label: "Precalificador", value: "namePrequalifier" },
                { label: "Estado en el proceso", value: "status" },
                { label: "Comentario de Exclusión", value: "commentExclusion" },
              ],
              content: datos,
            },
          ];
          const settings = {
            fileName: "participantes",
            extraLength: 3,
            writeOptions: {},
          };
          xlsx(planilla, settings);
          setCargandoDatosExcel(false);
        });
    }
  };

  const cargar = async () => {
    const url = UrlWs + `/process/${id_process}`;
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((datos) => {
        setDatosProceso(datos);
        setCargandoDatos(false);
        setUpdateProceso(false);
        setRecargar(Date.now());
      });
  };

  useEffect(() => {
    console.log("Update proces:? " + updateProceso);
    if (updateProceso === true && cargandoDatos === false) {
      console.log("Update proces: cargar? " + updateProceso);
      cargar();
    }
  }, [id_process, updateProceso]);

  return (
    <>
      <div
        className="content d-flex flex-column flex-column-fluid"
        id="kt_content"
      >
        <div className="toolbar" id="kt_toolbar">
          <div
            id="kt_toolbar_container"
            className="container-fluid d-flex flex-stack"
          >
            <div
              data-kt-swapper="true"
              data-kt-swapper-mode="prepend"
              data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
              className="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0"
            >
              <h1 className="d-flex text-dark fw-bolder fs-3 align-items-center my-1">
                 Editar proceso de Calificación
              </h1>
              <span className="h-20px border-gray-300 border-start mx-4"></span>
              <ul className="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li className="breadcrumb-item text-muted">
                  <a href="#" className="text-muted text-hover-primary">
                    Home
                  </a>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-300 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-dark">
                  Buscar Proceso de Calificación
                </li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3"></div>
          </div>
        </div>
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div className="container-xxl">
            <div className="row gy-5 g-xl-8">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DEL PROCESO
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <div className="row mb-8">
                      <div className="col-lg-9 col-sm-12 ">
                        {updateProceso === true || cargandoDatos === true ? (
                          <>
                            <PlaceholderColumnas
                              columnas={3}
                            ></PlaceholderColumnas>
                          </>
                        ) : (
                          <InformacionProceso
                            key="-editar_proceso"
                            proceso={datosProceso}
                            setUpdateProceso={setUpdateProceso}
                          />
                        )}
                      </div>
                      <div className="col-lg-3 col-sm-12 ">
                        {cargandoDatos === false &&
                        datosProceso != null &&
                        typeof datosProceso != "undefined" &&
                        (datosProceso.processStatus === "Eliminado" ||
                          datosProceso.processStatus === "Cerrado") ? (
                          <></>
                        ) : (
                          <div className="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                            <div className="row">
                              <div className="col-md-12">
                                <span className="fw-bolder fs-5 mb-5">
                                  Seleccione una opción
                                </span>
                              </div>
                            </div>
                            <div className="row">
                              <div className="col-md-12 d-grid gap-2">
                                <button
                                  data-kt-scroll-toggle="true"
                                  className="mt-4 text-start btn btn-sm btn-secondary btn-block"
                                  data-bs-toggle="modal"
                                  data-bs-target="#m-acCalificadora"
                                >
                                  <i className="fas fa-redo mr-2"></i>
                                  Actualizar Junta Calificadora
                                </button>

                                {cargandoDatos === false &&
                                datosProceso != null &&
                                typeof datosProceso != "undefined" ? (
                                  //&&
                                  //datosProceso.processStatus === "En Proceso"
                                  <button
                                    data-kt-scroll-toggle="true"
                                    className="text-start btn btn-sm btn-secondary btn-block"
                                    data-bs-toggle="modal"
                                    data-bs-target="#m-acPrecalificadores"
                                  >
                                    <i className="fas fa-redo mr-2"></i>
                                    Actualizar Precalificadores
                                  </button>
                                ) : (
                                  <Popup
                                    content={
                                      "Los participantes ya fueron asignados"
                                    }
                                    trigger={
                                      <button
                                        data-kt-scroll-toggle="true"
                                        className="deshabilitado text-start btn btn-sm btn-secondary btn-block"
                                      >
                                        <i className="fas fa-redo mr-2"></i>
                                        Actualizar Precalificadores
                                      </button>
                                    }
                                  />
                                )}

                                <button
                                  data-kt-scroll-toggle="true"
                                  className="text-start btn btn-sm btn-secondary btn-block"
                                  data-bs-toggle="modal"
                                  data-bs-target="#m-acParticipante"
                                  onClick={() => setLimpiar(limpiar + 1)}
                                >
                                  <i className="fas fa-redo mr-2"></i>
                                  Actualizar Participante
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                        Agregar / Excluir Funcionarios
                      </span>
                    </h3>
                  </div>
                  {cargandoDatos === false &&
                  datosProceso != null &&
                  typeof datosProceso != "undefined" &&
                  (datosProceso.processStatus === "Eliminado" ||
                    datosProceso.processStatus === "Cerrado") ? (
                    <></>
                  ) : (
                    <div className="card-body">
                      <div className="container-fluid d-flex flex-stack mt-2">
                        <div className="d-flex align-items-center gap-2 gap-lg-3">
                          <button
                            onClick={exportarExcel}
                            className="btn btn-secondary"
                            disabled={cargandoDatosExcel}
                          >
                            {cargandoDatosExcel ? (
                              "Generando datos..."
                            ) : (
                              <span>
                                <i className="fas fa-file-excel mr-2"></i>
                                Exportar Funcionarios a Excel
                              </span>
                            )}
                          </button>
                        
                            <button
                              type="button"
                              className="btn btn-secondary"
                              data-bs-toggle="modal"
                              data-bs-target="#m-excluir-funcionario"
                            >
                              <i className="fas fa-times"></i>Excluir
                              funcionarios
                            </button>
                          
                          {cargandoDatos === false &&
                          datosProceso != null &&
                          typeof datosProceso != "undefined" &&
                          datosProceso.processStatus === "En Proceso" ? (
                            <AsignarParticipantes
                              idProcess={id_process}
                            ></AsignarParticipantes>
                          ) : (
                            <></>
                          )}
                          {typeof datosProceso != "undefined" &&
                          datosProceso != null &&
                          (datosProceso.processStatus === "Eliminado" ||
                            datosProceso.processStatus === "Cerrado") ? (
                            <></>
                          ) : (
                            <div className="d-flex justify-content-end">
                              <button
                                className="btn btn-danger"
                                data-bs-toggle="modal"
                                data-bs-target="#m-eliminarProceso"
                                type="button"
                              >
                                <i className="fas fa-trash mr-2"></i>
                                Eliminar proceso
                              </button>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="col-xl-12 ">
                <div className="card">
                  <div className="card-header ">
                    <h3 className="card-title align-items-start flex-column ">
                      <span className="card-label fw-bolder text-dark ">
                         Participantes excluidos
                      </span>
                    </h3>
                  </div>
                  <div className="card-body">
                    <ParticipantesExcluidos
                      idProcess={id_process}
                      setUpdateProceso={setUpdateProceso}
                      setParticipanteExcluido={setParticipanteExcluido}
                      recargar={recargar}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade "
        id="m-excluir-funcionario"
        tabIndex="-1 "
        aria-hidden="true "
      >
        <div className="modal-dialog modal-dialog-centered mw-900px ">
          <div className="modal-content ">
            <div className="modal-header ">
              <h2>Excluir Funcionario del proceso</h2>

              <div
                className="btn btn-sm btn-icon btn-active-color-primary"
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1 ">X</span>
              </div>
            </div>
            <div className="modal-body py-lg-10 px-lg-10 ">
              <ExcluirFuncionario
                setUpdateProceso={setUpdateProceso}
                idProcess={id_process}
              />
            </div>
          </div>
        </div>
      </div>

      {datosProceso != null && typeof datosProceso != "undefined" ? (
        <>
          <EliminarProceso
            idProcess={id_process}
            setUpdateProceso={setUpdateProceso}
            yearProcess={datosProceso.yearProcess}
          />
          <ActualizarPrecalificadores idProcess={id_process} />
          <ActualizarJuntaCalificadora
            idProcess={datosProceso.id_process}
            qualifyingBoard={datosProceso.qualifyingBoard}
          />
        </>
      ) : (
        ""
      )}
      <ActualizarParticipante limpiar={limpiar} />
      <div
        className="modal fade "
        id="m-"
        tabIndex="-1 "
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-900px">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Cerrar Proceso de calificación</h2>
              <div
                className="btn btn-sm btn-icon btn-active-color-primary "
                data-bs-dismiss="modal"
              >
                <span className="svg-icon svg-icon-1 ">X</span>
              </div>
            </div>
            <div className="modal-body py-lg-10 px-lg-10 ">
              <div className="notice d-flex bg-light-danger rounded border-danger border border-dashed h-lg-100 p-6 ">
                <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap ">
                  <div className="mb-3 mb-md-0 fw-bold ">
                    <h4 className="text-gray-900 fw-bolder ">
                      ¿Esta seguro de cerrar el Proceso?
                    </h4>
                    <div className="fs-6 text-gray-700 pe-7 ">
                      Esta acción enviará automáticamente todas las
                      calificaciones con puntaje 70 a cada Funcionario para su
                      visualización y conformidad. Las que tengan puntaje
                      inferior a 70, quedarán en la bandeja de espera de RRHH,
                      para que este realice una entrevista personal con los
                      Funcionarios en cuestión antes de derivar la Calificación
                      al Funcionario
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EliminarExcluido
        participante={participanteExcluido}
        setUpdateProceso={setUpdateProceso}
      />
    </>
  );
};
